export enum AmplitudeEvent {
  ChatListOpened = "aichat_list_assistants",
  ChatOpened = "aichat_assistants_chat_opened",
  MessageSent = "aichat_message_sent",
  TemplateClicked = "aichat_template_clicked",

  DialogCreated = "aichat_dialog_created",
  DialogChosen = "aichat_dialog_chosen",
  DialogDeleted = "aichat_dialog_delete_confirmed",
  DialogEdited = "aichat_dialog_edit_confirmed",
  VoiceConversationOpened = "aichat_voice_conversation_chosen",
  VoiceConversationStart = "aichat_voice_conversation_start",
  VoiceConversationSentSuccess = "aichat_voice_conversation_sent_success",
  VoiceConversationSentFailure = "aichat_voice_conversation_sent_failure",
  VoiceTranscribeSuccess = "aichat_stt_transcribation_success",
  VoiceTranscribeFailure = "aichat_stt_trancribation_failure",
}
